import React from 'react';

// Inputs
import { TextInputField, CalendarField, DropDownField, Button } from '../../../../helpers';

import { FileUpload } from "primereact/fileupload";



const TrackingDetails = (props) => {
    const { trackingDetails, logisticPartners } = props

    const handleTrackingDetailsInputChange = (event) => {
        trackingDetails[event.target.name] = event.target.value
        props.setTrackingDetails({...trackingDetails})
    }
    
    return (
        <>
            <div className="flex flex-row justify-content-between">
                <h4 className="mt-0 ml-2 mb-2">Tracking Details</h4>
            </div>
            <div className="p-card">
                <div className="grid pl-3 pr-2 md:px-0">
                    <div className="flex flex-column col-12 lg:col-4 lg:mb-0">
                        <DropDownField name="logisticPartnerId" labelText="Logistic Partner" options={logisticPartners} optionLabel="partnerNameWithState" optionValue="logisticPartnerId" value={trackingDetails?.logisticPartnerId} onChange={(event) => handleTrackingDetailsInputChange(event)} errorMessage={ props.trackingDetailsFormErrors.logisticPartnerId } />
                    </div>
                    <div className="flex flex-column col-12 lg:col-4 lg:mb-0">
                        <TextInputField name="trackingNumber" labelText="Tracking Number" value={trackingDetails?.trackingNumber} onChange={(event)=>handleTrackingDetailsInputChange(event)} errorMessage={ props.trackingDetailsFormErrors.trackingNumber } />
                    </div>
                    <div className="flex flex-column col-12 lg:col-4 lg:mb-0">
                        <TextInputField name="trackingOrderLink" labelText="Tracking Order Link" value={trackingDetails?.trackingOrderLink} onChange={(event)=>handleTrackingDetailsInputChange(event)} errorMessage={ props.trackingDetailsFormErrors.trackingOrderLink } />
                    </div>
                    <div className="flex flex-column col-12 lg:col-4 lg:mb-0">
                        <CalendarField name="expectedDeliveryDate" labelText="Expected Delivery Date" placeholder="" minDate={new Date()} value={trackingDetails?.expectedDeliveryDate ? new Date(trackingDetails.expectedDeliveryDate) : null} onChange={(event)=>handleTrackingDetailsInputChange(event)} errorMessage={ props.trackingDetailsFormErrors.expectedDeliveryDate } />
                    </div>
                    <div className="grid upload-file mt-2">
                        <div className="mx-2 flex align-items-center col-12 mb-2">
                            <label htmlFor="trackingDocument" className="text-xs mb-1 mr-2">Tracking Doc: </label>
                            {
                                !trackingDetails?.trackingDocument ?
                                    <div>
                                        <FileUpload mode="basic" name="trackingDocument" accept="image/pdf/*" customUpload auto multiple chooseLabel="Upload Document" uploadHandler={(files) => props.fileUploadHandler(files)} />
                                    </div>
                                    :
                                    typeof(trackingDetails?.trackingDocument) === 'string' ?
                                        <div>
                                            <a href={trackingDetails?.trackingDocument} className="view-btn" target="_blank">View</a>
                                        </div>
                                        :
                                        <div className='flex justify-content-center align-items-center ml-2'>
                                            <label key={trackingDetails?.trackingDocument?.fileName}> <b> {trackingDetails?.trackingDocument?.fileName} &nbsp;&nbsp; </b></label>
                                            <Button className="decrement-btn-icon" icon="pi pi-minus-circle" text onClick={() => props.removeTrackingDocument()} size="small" />
                                        </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TrackingDetails